import { useManagementSettingsViewModel } from "@/features/management-settings/view-models/select-management-settings-view-model";
import { Tabs, TabsList, TabsTrigger } from "@spz/ui/components/tabs";
import { Typography } from "@spz/ui/components/typography";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom";

const ManagementSettings: FC = () => {
  const { t } = useTranslation();
  const { activeTab, tabs } = useManagementSettingsViewModel();

  return (
    <div data-testid="org-settings-container">
      <div className="flex justify-between">
        <Typography variant="h5">{t("organization_settings_title")}</Typography>
      </div>

      <Tabs value={activeTab} className="w-full">
        <TabsList>
          {tabs.map((tab) => (
            <TabsTrigger
              asChild
              key={tab.value}
              value={tab.value}
              data-testid={tab.testId}
            >
              <Link
                className="w-full h-full flex items-center justify-center"
                to={tab.path}
              >
                {t(tab.labelKey)}
              </Link>
            </TabsTrigger>
          ))}
        </TabsList>

        <div className="mt-4 flex flex-col">
          <Outlet />
        </div>
      </Tabs>
    </div>
  );
};

export default ManagementSettings;
